// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_3dEZZ","icon":"index_icon_1Dkt3"};